// components/Features.js
import React from 'react';
import './Features.css';
import { Link } from 'react-router-dom';

const Features = () => {
  const features = [
    {
      title: 'Internet-Scale Data Generation',
      description: 'Large-scale, meticulously curated datasets for training next-generation ML systems. Open-source and Enterprise options.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 16H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 4C16 4 10 8 10 16C10 24 16 28 16 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 4C16 4 22 8 22 16C22 24 16 28 16 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      highlights: ['10B+ data points', 'Real-time processing', '99.9% uptime'],
      interest: 'enterprise-datasets'
    },
    {
      title: 'Custom Datasets',
      description: 'We build datasets specifically for your research or business need. These datasets are owned by you and never shared.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <ellipse cx="16" cy="8" rx="10" ry="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 8V16C6 17.66 10.48 19 16 19C21.52 19 26 17.66 26 16V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 16V24C6 25.66 10.48 27 16 27C21.52 27 26 25.66 26 24V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="24" cy="24" r="6" fill="black" stroke="currentColor" strokeWidth="2"/>
            <path d="M24 21V27M21 24H27" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      highlights: ['Domain-specific', 'Quality guaranteed', 'Rapid delivery'],
      interest: 'custom-datasets'
    },
    {
      title: 'Expert Consulting',
      description: 'Partner with our ML engineers to accelerate your AI development. From strategy to implementation, we guide your data journey.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 4C11.58 4 8 7.58 8 12C8 14.52 9.08 16.78 10.84 18.26C11.58 18.88 12 19.82 12 20.84V22C12 23.1 12.9 24 14 24H18C19.1 24 20 23.1 20 22V20.84C20 19.82 20.42 18.88 21.16 18.26C22.92 16.78 24 14.52 24 12C24 7.58 20.42 4 16 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 24H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M14 27H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      highlights: ['End-to-end support', 'Best practices', 'Proven expertise'],
      interest: 'consulting'
    }
  ];

  return (
    <section className="features" id='features'>
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">
            Powering AI with <span className="title-gradient">Precision Data</span>
          </h2>
          {/* <p className="features-subtitle">
            From web-scale collection to synthetic generation, we provide the data foundation
            that leading AI teams rely on.
          </p> */}
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
                <div className="icon-glow"></div>
              </div>

              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>

              {/* <div className="feature-highlights">
                {feature.highlights.map((highlight, idx) => (
                  <div key={idx} className="highlight">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M13 4L6 11L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{highlight}</span>
                  </div>
                ))}
              </div> */}
            <Link to={`/contact?interest=${feature.interest}`} className='feature-link'>
                Learn more
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
